export const createKeyMap = <T extends Record<string, unknown>, K extends keyof T>(list: T[], key: K) => {
  return list.reduce<Record<string, T>>((acc, curr) => {
    const keyVal = curr[key] as string;
    acc[keyVal] = curr;
    return acc;
  }, {});
};
